import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import {
  Button,
  Col,
  Row,
  Card,
  CardBody,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import ButtonIcon from "../../common/ButtonIcon";
import APICall from "../../../services/apiCall";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import ToolTipItem from "../../common/ToolTipItem";
import {
  faCircleCheck,
  faCircleXmark,
  faClockRotateLeft,
  faHistory,
  faKey,
  faPencilAlt,
  faRightLeft,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import ModalCustom from "../../common/ModalCustom";
import MasterCustomerHistoryModal from "../../ModalPopup/MasterCustomerHistoryModal";
import UserUpdateEmailModal from "../../ModalPopup/UserUpdateEmailModal";
import AppContext from "../../../context/Context";
import RequestKeyModal from "../../ModalPopup/RequestKeyModal";
import ShowDataAvailableModal from "../../ModalPopup/ShowDataAvailableModal";
import DemoPracticesModal from "../../ModalPopup/DemoPracticesModal";
import TransferCustomerModal from "../../ModalPopup/TransferCustomerModal";
import AddNewCustomerModal from "../../ModalPopup/AddNewCustomerModal";
import EditPracticeLocationModal from "../../ModalPopup/EditPracticeLocationModal";
import SPCDetailsModal from "../../ModalPopup/SPCDetailsModal";
import PartnerCustomerListApiAccessModal from "../../ModalPopup/PartnerCustomerListApiAccessModal";
import PracticeLocationHistoryModal from "../../ModalPopup/PracticeLocationHistoryModal";
import { Box, Checkbox } from "@mui/material";
import APIPortalTable from "../../common/Table/APIPortalTable";
import exportToCsv from "../../../helpers/exportToCsv";
import AddTestingDemoPracticeModal from "../../ModalPopup/AddTestingDemoPracticeModal";
import PaymentApiConfigurationModal from "../../ModalPopup/PaymentApiConfigurationModal";

const buttonToLink = {
  textAlign: "left",
  color: "#2c7be5",
  background: "none",
  margin: 0,
  padding: 0,
  border: "none",
  cursor: "pointer",
  fontWeight: 400,
  fontFamily:
    // eslint-disable-next-line quotes
    '"Open Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  textDecoration: "underline",
};
const buttonToLinkHistory = {
  textAlign: "left",
  color: "#58B1D3",
  background: "none",
  margin: 0,
  padding: 0,
  border: "none",
  cursor: "pointer",
  fontWeight: 400,
  float: "right",
};

const PartnerCustomerList = ({
  devid,
  appid,
  isActionAllowed,
  applicationDetails,
  applicationList = [],
  setPartnerCustomerListForLiveUpdate,
}) => {
  const [activity, setActivity] = useState([]);
  const [selectedPartnerCustomer, setSelectedPartnerCustomer] = useState({});
  const [masterCustomerHistory, setMasterCustomerHistoryData] = useState([]);
  //const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showFilterSearch, setShowFilterSearch] = useState(false);
  const [
    showMasterCustomerHistoryModal,
    setShowMasterCustomerHistoryModal,
  ] = useState(false);
  const [showUserUpdateEmailModal, setShowUserUpdateEmailModal] = useState(
    false
  );
  const [
    showPracticeLocationUpdateModal,
    setShowPracticeLocationUpdateModal,
  ] = useState(false);
  const [showDataAvailableModal, setShowDataAvailableModal] = useState(false);
  const [keyBtnModal, setKeyBtnModal] = useState(false);
  const [updateDataFlag, setUpdateDataFlag] = useState(true);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [selectedMasterCustomerID, setSelectedMasterCustomerID] = useState("");
  const [demoPracticesModal, setDemoPracticesModal] = useState(false);
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [searchCustomerValue, setSearchedCustomerValue] = useState("");
  const [searchedCustomers, setSearchedCustomers] = useState([]);
  const [noSearchCustomers, setNoSearchCustomers] = useState(false);
  const [addCustomerParams, setAddCustomerParams] = useState({});
  const [transferCustomerModal, setTransferCustomerModal] = useState(false);
  const [editPracticeLocationModal, setEditPracticeLocationModal] = useState(
    false
  );
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [
    selectedMasterCustIDPracLocation,
    setSelectedMasterCustIDPracLocation,
  ] = useState("");
  const [
    selectCustomerForPracticeLocationUpdate,
    setSelectCustomerForPracticeLocationUpdate,
  ] = useState({});
  const [openSPCDetailsModal, setOpenSPCDetailsModal] = useState(false);
  const [apiAccessCommentModal, setApiAccessCommentModal] = useState(false);
  const [apiAccessData, setApiAccessData] = useState({});
  const [isRefresh, setIsRefresh] = useState(false);
  const [
    practiceLocationHistoryModal,
    setPracticeLocationHistoryModal,
  ] = useState(false);
  const [
    masterCustIdForPracticeLocationHistory,
    setMasterCustIdForPracticeLocationHistory,
  ] = useState("");
  const [openPopupAddressModal, setOpenPopupAddressModal] = useState(false);
  const [practiceLocationAddress, setPracticeLocationAddress] = useState("");
  const [isDemoAccountSelection, setIsDemoAccountSelection] = useState({});
  const [openAddDemoPracticeModal, setOpenAddDemoPracticeModal] = useState(
    false
  );
  const [openPaymentApiConfModal, setOpenPaymentApiConfModal] = useState(false);
  const [configureSelectedRow, setConfigureSelectedRow] = useState({});
  const [isNewCustomerFlow, setIsNewCustomerFlow] = useState(false);
  const [pendingCustomerParams, setPendingCustomerParams] = useState({});
  const [isApiAccessOnFlow, setIsApiAccessOnFlow] = useState(false);
  const apiAccessLocationSavedRef = useRef(false);
  const pendingLocationBodyRef = useRef(null);
  const pendingCustomerCreationRef = useRef(null);
  const newCustomerAccessSavingRef = useRef(false);
  let materialColumns = [];

  let apiAccessListForFilter = ["ON", "OFF", "ALL"];

  const { loginUserDetails, accessToken } = useContext(AppContext);

  const renderTooltip = (id, props) => (
    <Tooltip id={id} {...props}>
      Click here to check if the data is available or not
    </Tooltip>
  );

  const filterColumns = (columns, demoPracticeArray) => {
    if (
      loginUserDetails.is_partner === "0" &&
      !isActionAllowed("liApiAccessGridButton")
    ) {
      let idx = materialColumns.findIndex((col) => col.header === "API Access");
      materialColumns.splice(idx, 1);
    }
    if (
      (loginUserDetails.is_partner === "0" &&
        !isActionAllowed("liUpdatePracticeLocationAccess")) ||
      !loginUserDetails.is_partner === "1"
    ) {
      let idx = materialColumns.findIndex(
        (col) => col.header === "Practice Location Access"
      );
      materialColumns.splice(idx, 1);
    }
    if (
      (loginUserDetails.is_partner === "0" &&
        !isActionAllowed("liCheckDataAvailableGridButton")) ||
      !loginUserDetails.is_partner === "1"
    ) {
      let idx = materialColumns.findIndex(
        (col) => col.accessorKey === "is_data_available"
      );
      materialColumns.splice(idx, 1);
    }

    if (loginUserDetails.is_partner === "1") {
      if (loginUserDetails.user_type.toLowerCase() === "user") {
        materialColumns = materialColumns.filter((col) => {
          return !(col.header === "API Access");
        });
      }
      let columnObj = {
        accessorKey: "opt_flag",
        header: "Current API status",
        filterVariant: "select",
        filterFn: (row, id, filterValue) => {
          if (filterValue?.toLowerCase() === "on") {
            return row.getValue(id) === "1";
          } else if (filterValue?.toLowerCase() === "off") {
            return row.getValue(id) === "0";
          } else {
            return row.getValue(id);
          }
        },
        filterSelectOptions: apiAccessListForFilter,
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          return (
            <div className="d-flex justify-content-center">
              {renderedCellValue === "0" ? (
                <FontAwesomeIcon
                  className="fa-2x"
                  color="#E63757"
                  icon={faCircleXmark}
                />
              ) : (
                <FontAwesomeIcon
                  className="fa-2x"
                  color="#00D27A"
                  icon={faCircleCheck}
                />
              )}
            </div>
          );
        },
        classes: "border-0 align-middle",
        headerClasses: "border-0",
        size: 230,
        sort: true,
        csvExport:false,
        csvFormatter: (cell, row, rowIndex) => {
          if (cell) {
            if (cell == "1") {
              return "ON";
            } else {
              return "OFF";
            } 
          }else{
            return "--"
          }
        },
      };
      let apiAccessColumn = materialColumns.find(col => col.header === "API Access");
      materialColumns = materialColumns.filter(col => col.header !== "API Access");
      
      materialColumns.splice(10, 0, columnObj);
      
      if (apiAccessColumn && loginUserDetails.user_type.toLowerCase() !== "user") {
        materialColumns.splice(9, 0, apiAccessColumn);
      }
    }

    if (activity?.length > 0 && activity[0].payment_api_config_flag === "1") {
      let columnObj = {
        header: "Payment API Configuration",
        filterVariant: "select",
        size: 150,
        filterFn: (row, id, filterValue) => {
          if (filterValue?.toLowerCase() === "on") {
            return row.getValue(id) === "1";
          } else if (filterValue?.toLowerCase() === "off") {
            return row.getValue(id) === "0";
          } else {
            return row.getValue(id);
          }
        },
        filterSelectOptions: apiAccessListForFilter,
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          let rowValue = row.original;
          if (rowValue.is_payment_api_configured === "1") {
            return (
              <>
                <Fragment>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 200 }}
                    // delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id={"configure_payment_api" + row.id}>
                        Click here to view/update Payment API configuration
                      </Tooltip>
                    }
                  >
                    <Button
                      className="btn btn-success btn-xs"
                      onClick={() => {
                        setOpenPaymentApiConfModal(true);
                        setConfigureSelectedRow(row);
                      }}
                    >
                      Configured
                    </Button>
                  </OverlayTrigger>
                </Fragment>
              </>
            );
          } else {
            return (
              <Fragment>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  // delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id={"configure_payment_api" + row.id}>
                      Click here to configure payment API
                    </Tooltip>
                  }
                >
                  <Button
                    className="btn btn-danger btn-xs"
                    onClick={() => {
                      setOpenPaymentApiConfModal(true);
                      setConfigureSelectedRow(row);
                    }}
                  >
                    Configure
                  </Button>
                </OverlayTrigger>
              </Fragment>
            );
          }
        },
        classes: "border-0 align-middle",
        headerClasses: "border-0",
        sort: true,
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "1") {
            return "ON";
          } else {
            return "OFF";
          }
        },
      };
      materialColumns.splice(9, 0, columnObj);
    }

    if (
      loginUserDetails.is_partner === "1" ||
      (activity?.length > 0 && activity[0].practice_key_flag === "0")
    ) {
      materialColumns = materialColumns.filter((col) => {
        return !(col.header === "Is Demo Account?");
      });
    }

    return materialColumns;
  };

  useEffect(() => {
    if (appid) {
      setFilteredColumns(filterColumns(materialColumns));
      // setUpdateDataFlag(true);
    }
  }, [appid, isRefresh, activity]);

  useEffect(() => {
    if (openAddDemoPracticeModal === false) {
      setUpdateDataFlag(true);
    }
  }, [openAddDemoPracticeModal]);

  useEffect(() => {
    if (editPracticeLocationModal === false) {
      if (isNewCustomerFlow) {
        resetNewCustomerFlow();
      }
      if (isApiAccessOnFlow && !apiAccessLocationSavedRef.current) {
        setIsApiAccessOnFlow(false);
      }
    }
  }, [editPracticeLocationModal]);

  useEffect(() => {
    if (apiAccessCommentModal === false && isApiAccessOnFlow) {
      setIsApiAccessOnFlow(false);
      apiAccessLocationSavedRef.current = false;
      pendingLocationBodyRef.current = null;
    }
  }, [apiAccessCommentModal]);

  function handleUserTypeUpdateClick(values) {
    let currentAPIAccess = apiAccessData.currentAPIAccess;
    let data = apiAccessData.data;

    if (currentAPIAccess !== data.opt_flag) {
      setLoading(true);

      var body = {
        uid: data.api_unique_id,
        app_id: appid,
        master_customer_id: data.master_customer_id,
        opt_flag: currentAPIAccess,
        app_name: data.app_name,
        dev_id: devid,
        partner_name: data.partner_name,
        add_updated_by: loginUserDetails.user_name,
        old_flag: data.opt_flag,
        is_add_updated_by_admin:
          loginUserDetails.is_partner === "0" ? "true" : "false",
        comment: values.comment,
      };

      if (apiAccessLocationSavedRef.current) {
        body.request_from = "PortalPracticeLocationSelection";
      }
      const showApiError = (error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
        setLoading(false);
      };

      const updateApiAccess = () => {
      APICall.servertrip(
        "PUT",
        "auth_practice_details",
        loginUserDetails,
        undefined,
        body
      ).then(
        (res) => {
          setUpdateDataFlag(true);
          setLoading(false);
          setApiAccessCommentModal(false);
        }, showApiError);
      };

      let pendingLocationBody = pendingLocationBodyRef.current;
      if (pendingLocationBody) {
        APICall.servertrip(
          "POST",
          "practice_location",
          loginUserDetails,
          undefined,
          pendingLocationBody
        ).then(() => {
          pendingLocationBodyRef.current = null;
          toast.success("Practice Location successfully changed");
          updateApiAccess();
        }, showApiError);
      } else {
        updateApiAccess();
      }
    }
  }

  const selectOptionsArr = [
    {
      value: 0,
      label: "OFF",
    },
    {
      value: 1,
      label: "ON",
    },
  ];

  if (loginUserDetails.is_partner === "0") {
    materialColumns = [
      {
        accessorKey: "master_customer_id", //simple recommended way to define a column
        header: "Master Customer ID",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          const handleMasterIdHistoryClick = () => {
            setSelectedPartnerCustomer(row.original);
            setShowMasterCustomerHistoryModal(true);
          };
          
            return (
              <>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id={"masterCustomerId" + row.id}>
                      Click here to see details
                    </Tooltip>
                  }
                >
                  <Button
                    id={"masterCustomerId" + row.id}
                    className="fs--1"
                    style={buttonToLink}
                    onClick={() => {
                      setSelectedMasterCustIDPracLocation(
                        row.original.master_customer_id
                      );
                      setOpenSPCDetailsModal(true);
                    }}
                  >
                    {row.original.master_customer_id}
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id={"masterCustomerIdHistory" + row.id}>
                      Click here to see history
                    </Tooltip>
                  }
                >
                  <Button
                    id={"masterCustomerIdHistory" + row.id}
                    style={buttonToLinkHistory}
                    onClick={() => handleMasterIdHistoryClick()}
                    className="ml-3 mr-3"
                  >
                    <FontAwesomeIcon size="sm" icon={faHistory} />
                  </Button>
                </OverlayTrigger>

               
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 200 }}
                    overlay={
                      <Tooltip id={"mpAccessFlag" + row.id}>
                        Click here to see practice key(s)
                      </Tooltip>
                    }
                  >
                    <Button
                      id={"mpAccessFlag" + row.id}
                      style={buttonToLinkHistory}
                      onClick={() => {
                        setSelectedMasterCustomerID(
                          row.original.master_customer_id
                        );
                        setKeyBtnModal(true);
                      }}
                      className="mr-3"
                    >
                      <FontAwesomeIcon size="sm" icon={faKey} />
                    </Button>
                  </OverlayTrigger>
               
              </>
            );
          
        }, //optional custom cell render
      },
      {
        accessorKey: "practice_name", //simple recommended way to define a column
        header: "Practice Name",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,

        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
      },
      {
        accessorKey: "po_user_name", //simple recommended way to define a column
        header: "User",
        size: 350,
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,
        enableClickToCopy: true,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell, row, renderedCellValue }) => {
          const handleEmailUpdateClick = () => {
            setSelectedPartnerCustomer(row.original);
            setShowUserUpdateEmailModal(true);
          };
          return (
            <div style={{ width: 350 }}>
              <span
                style={{
                  float: "left",
                  width: "75%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {renderedCellValue}
              </span>
              {isActionAllowed("liUpdateUserEmailGridButton") && (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id={"pouserNameUpdate" + row.index}>
                      Click here to update email
                    </Tooltip>
                  }
                >
                  <Button
                    id={"pouserNameUpdate" + row.index}
                    style={buttonToLinkHistory}
                    onClick={() => handleEmailUpdateClick()}
                    className="mr-3"
                  >
                    <FontAwesomeIcon size="sm" icon={faPencilAlt} />
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          );
        }, //optional custom cell render
      },
      {
        accessorKey: "authorized_on", //simple recommended way to define a column
        header: "Authorized Date",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
        sortingFn: (rowA, rowB, columnId) => {
          let dateA = Date.parse(rowA?.original[columnId]);
          let dateB = Date.parse(rowB?.original[columnId]);
          if (dateA < dateB) {
            return -1;
          } else if (dateA > dateB) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      {
        accessorKey: "last_refresh", //simple recommended way to define a column
        header: "SPC Refresh Date",
        sort: true,
        csvExport: true,
        enableResizing: false,
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "01/01/1900 00:00:00") {
            return "--";
          } else {
            return cell;
          }
        },
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
        sortingFn: (rowA, rowB, columnId) => {
          let dateA = Date.parse(rowA?.original[columnId]);
          let dateB = Date.parse(rowB?.original[columnId]);
          if (dateA < dateB) {
            return -1;
          } else if (dateA > dateB) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      {
        accessorKey: "created_date", //simple recommended way to define a column
        header: "Created Date",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: true,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
        sortingFn: (rowA, rowB, columnId) => {
          let dateA = Date.parse(rowA?.original[columnId]);
          let dateB = Date.parse(rowB?.original[columnId]);
          if (dateA < dateB) {
            return -1;
          } else if (dateA > dateB) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      {
        accessorKey: "practice_id1", //simple recommended way to define a column
        header: "Practice Location Access",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        showColumnFilters: true,
        enableResizing: false,
        size: 230,
        enableClickToCopy: true,
        enableSorting: true,
        //custom conditional format and styling
        Cell: ({ cell, row, renderedCellValue }) => {
          const handlePracticeLocationUpdateClick = () => {
            setEditPracticeLocationModal(true);
            setSelectedMasterCustIDPracLocation(
              row.original.master_customer_id
            );
            setSelectCustomerForPracticeLocationUpdate(row.original);
          };
          return (
            <>
              <Box
                width={300}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                <span
                  className="w-50"
                  style={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                  onClick={() => {
                    setPracticeLocationAddress(renderedCellValue);
                    setOpenPopupAddressModal(true);
                  }}
                >
                  {renderedCellValue}
                </span>
                <div>
                  {((loginUserDetails.is_partner === "1" &&
                    (loginUserDetails.user_type.toLowerCase() ===
                      "super admin" ||
                      loginUserDetails.user_type.toLowerCase() === "admin")) ||
                    loginUserDetails.is_partner === "0") && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 200, hide: 200 }}
                      overlay={
                        <Tooltip id={"practiceLocationUpdate" + row.id}>
                          Click here to select practices
                        </Tooltip>
                      }
                    >
                      <Button
                        id={"practiceLocationUpdate" + row.id}
                        style={buttonToLinkHistory}
                        onClick={() => handlePracticeLocationUpdateClick()}
                        className="mr-3"
                      >
                        <FontAwesomeIcon size="sm" icon={faPencilAlt} />
                      </Button>
                    </OverlayTrigger>
                  )}
                </div>
              </Box>
            </>
          );
        },
      },
      {
        // filterVariant: 'range', //if not using filter modes feature, use this instead of filterFn
        header: "Location History",
        showColumnFilters: false,
        enableResizing: false,
        size: 150,
        csvExport: false,
        //custom conditional format and styling
        Cell: ({ cell, row, renderedCellValue }) => {
          return (
            <>
              <Fragment>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip>Click here to check location history</Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    icon={faClockRotateLeft}
                    cursor="pointer"
                    onClick={() => {
                      setPracticeLocationHistoryModal(true);
                      setMasterCustIdForPracticeLocationHistory(
                        row.original.master_customer_id
                      );
                    }}
                  />
                </OverlayTrigger>
              </Fragment>
            </>
          );
        },
      },
      {
        // filterVariant: 'range', //if not using filter modes feature, use this instead of filterFn
        header: "Is Demo Account?",
        accessorKey: "is_demo_practice",
        showColumnFilters: false,
        enableResizing: false,
        size: 130,
        csvExport: true,
        csvFormatter: (cell, row, rowIndex) => {
          return cell;
        },
        //custom conditional format and styling
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          return (
            <>
              <Checkbox
                style={{ padding: "0px" }}
                defaultChecked={row.original.is_demo_practice === "1"}
                size="small"
                onChange={(e) => {
                  setIsDemoAccountSelection(row.original);
                  setOpenAddDemoPracticeModal(true);
                }}
              />
            </>
          );
        },
      },
      {
        accessorKey: "opt_flag",
        header: "API Access",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell) {
            if (cell === "1") {
              return "ON";
            } else {
              return "OFF";
            } 
          }else{
            return "--"
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,
        filterVariant: "select",
        filterFn: (row, id, filterValue) => {
          if (filterValue?.toLowerCase() === "on") {
            return row.getValue(id) === "1";
          } else if (filterValue?.toLowerCase() === "off") {
            return row.getValue(id) === "0";
          } else {
            return row.getValue(id);
          }
        },
        filterSelectOptions: apiAccessListForFilter,
        showColumnFilters: true,
        size: 150,
        //custom conditional format and styling
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          return loginUserDetails.is_partner === "0" ? (
            <ButtonGroup>
              <Button
                id="btnOnAc"
                size="sm"
                className={
                  renderedCellValue === "1"
                    ? "btn btn-xs btn-success"
                    : "btn btn-xs btn-secondary"
                }
                onClick={() => {
                  if (renderedCellValue !== "1") {
                    setUpdateDataFlag(false);
                    setApiAccessData({
                      currentAPIAccess: "1",
                      data: row.original,
                    });
                    apiAccessLocationSavedRef.current = false;
                    pendingLocationBodyRef.current = null;
                    setIsApiAccessOnFlow(true);
                    setSelectedMasterCustIDPracLocation(
                      row.original.master_customer_id
                    );
                    setSelectCustomerForPracticeLocationUpdate(row.original);
                    setEditPracticeLocationModal(true);
                  }
                }}
              >
                ON
              </Button>
              <Button
                id="btnOffAc"
                size="sm"
                className={
                  renderedCellValue === "1"
                    ? "btn btn-xs btn-secondary"
                    : "btn btn-xs btn-danger"
                }
                onClick={() => {
                  if (renderedCellValue !== "0") {
                    setApiAccessCommentModal(true);
                    setUpdateDataFlag(false);
                    setApiAccessData({
                      currentAPIAccess: "0",
                      data: row.original,
                    });
                  }
                }}
              >
                OFF
              </Button>
            </ButtonGroup>
          ) : (
            <ButtonGroup>
              {renderedCellValue === "1" && (
                <Button
                  id="btnOffAc"
                  size="sm"
                  className="btn btn-xs btn-danger"
                  onClick={() => {
                    if (renderedCellValue !== "0") {
                      setApiAccessCommentModal(true);
                      setUpdateDataFlag(false);
                      setApiAccessData({
                        currentAPIAccess: "0",
                        data: row.original,
                      });
                    }
                  }}
                >
                  Turn OFF
                </Button>
              )}
            </ButtonGroup>
          );
        },
      },
      {
        accessorKey: "is_data_available", //simple recommended way to define a column
        header: "Is Data Available",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        showColumnFilters: true,
        enableResizing: true,
        size: 180,
        enableClickToCopy: true,
        enableSorting: false,
        //custom conditional format and styling
        Cell: ({ cell, row, renderedCellValue }) => {
          return (
            <>
              {row.original.opt_flag === "1" ? (
                <Fragment>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 200 }}
                    // delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("deletePaymentCardBtn" + row.id)}
                  >
                    <Button
                      className="btn btn-success btn-xs"
                      onClick={() => {
                        setSelectedMasterCustomerID(
                          row.original.master_customer_id
                        );
                        setShowDataAvailableModal(true);
                      }}
                    >
                      Check
                    </Button>
                  </OverlayTrigger>
                </Fragment>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  } else {
    materialColumns = [
      {
        accessorKey: "master_customer_id", //simple recommended way to define a column
        header: "Master Customer ID",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,

        enableResizing: false,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          const handleMasterIdHistoryClick = () => {
            setSelectedPartnerCustomer(row.original);
            setShowMasterCustomerHistoryModal(true);
          };

          
            return (
              <>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id={"masterCustomerId" + row.id}>
                      Click here to see details
                    </Tooltip>
                  }
                >
                  <Button
                    id={"masterCustomerId" + row.id}
                    className="fs--1"
                    style={buttonToLink}
                    onClick={() => {
                      setSelectedMasterCustIDPracLocation(
                        row.original.master_customer_id
                      );
                      setOpenSPCDetailsModal(true);
                    }}
                  >
                    {row.original.master_customer_id}
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id={"masterCustomerIdHistory" + row.id}>
                      Click here to see history
                    </Tooltip>
                  }
                >
                  <Button
                    id={"masterCustomerIdHistory" + row.id}
                    style={buttonToLinkHistory}
                    onClick={() => handleMasterIdHistoryClick()}
                    className="ml-3 mr-3"
                  >
                    <FontAwesomeIcon size="sm" icon={faHistory} />
                  </Button>
                </OverlayTrigger>

                {row.original.is_demo_practice !== "1" && (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 200 }}
                    overlay={
                      <Tooltip id={"mpAccessFlag" + row.id}>
                        Click here to see practice key(s)
                      </Tooltip>
                    }
                  >
                    <Button
                      id={"mpAccessFlag" + row.id}
                      style={buttonToLinkHistory}
                      onClick={() => {
                        setSelectedMasterCustomerID(
                          row.original.master_customer_id
                        );
                        setKeyBtnModal(true);
                      }}
                      className="mr-3"
                    >
                      <FontAwesomeIcon size="sm" icon={faKey} />
                    </Button>
                  </OverlayTrigger>
                )}
              </>
            );
          
        }, //optional custom cell render
      },
      {
        accessorKey: "practice_name", //simple recommended way to define a column
        header: "Practice Name",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,

        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
      },
      {
        accessorKey: "po_user_name", //simple recommended way to define a column
        header: "User",

        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        size: 350,
        enableResizing: true,
        enableClickToCopy: true,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell, row, renderedCellValue }) => {
          const handleEmailUpdateClick = () => {
            setSelectedPartnerCustomer(row.original);
            setShowUserUpdateEmailModal(true);
          };
          return (
            <div style={{ width: 350 }}>
              <span
                style={{
                  float: "left",
                  width: "75%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {renderedCellValue}
              </span>
              {isActionAllowed("liUpdateUserEmailGridButton") && (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip id={"pouserNameUpdate" + row.index}>
                      Click here to update email
                    </Tooltip>
                  }
                >
                  <Button
                    id={"pouserNameUpdate" + row.index}
                    style={buttonToLinkHistory}
                    onClick={() => handleEmailUpdateClick()}
                    className="mr-3"
                  >
                    <FontAwesomeIcon size="sm" icon={faPencilAlt} />
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "authorized_on", //simple recommended way to define a column
        header: "Authorized Date",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
        sortingFn: (rowA, rowB, columnId) => {
          let dateA = Date.parse(rowA?.original[columnId]);
          let dateB = Date.parse(rowB?.original[columnId]);
          if (dateA < dateB) {
            return -1;
          } else if (dateA > dateB) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      {
        accessorKey: "last_refresh", //simple recommended way to define a column
        header: "SPC Refresh Date",
        sort: true,
        csvExport: true,
        enableResizing: false,
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "01/01/1900 00:00:00") {
            return "--";
          } else {
            return cell;
          }
        },
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
        sortingFn: (rowA, rowB, columnId) => {
          let dateA = Date.parse(rowA?.original[columnId]);
          let dateB = Date.parse(rowB?.original[columnId]);
          if (dateA < dateB) {
            return -1;
          } else if (dateA > dateB) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      {
        accessorKey: "created_date", //simple recommended way to define a column
        header: "Created Date",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: true,
        // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
        Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
        sortingFn: (rowA, rowB, columnId) => {
          let dateA = Date.parse(rowA?.original[columnId]);
          let dateB = Date.parse(rowB?.original[columnId]);
          if (dateA < dateB) {
            return -1;
          } else if (dateA > dateB) {
            return 1;
          } else {
            return 0;
          }
        },
      },
      {
        accessorKey: "practice_id1", //simple recommended way to define a column
        header: "Practice Location Access",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,
        showColumnFilters: true,
        enableResizing: true,
        size: 230,
        enableClickToCopy: true,
        enableSorting: true,
        //custom conditional format and styling
        Cell: ({ cell, row, renderedCellValue }) => {
          const handlePracticeLocationUpdateClick = () => {
            setEditPracticeLocationModal(true);
            setSelectedMasterCustIDPracLocation(
              row.original.master_customer_id
            );
            setSelectCustomerForPracticeLocationUpdate(row.original);
          };
          return (
            <>
              <Box
                width={300}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                <span
                  className="w-50"
                  style={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                  onClick={() => {
                    setPracticeLocationAddress(renderedCellValue);
                    setOpenPopupAddressModal(true);
                  }}
                >
                  {renderedCellValue}
                </span>
                <div>
                  {((loginUserDetails.is_partner === "1" &&
                    (loginUserDetails.user_type.toLowerCase() ===
                      "super admin" ||
                      loginUserDetails.user_type.toLowerCase() === "admin")) ||
                    loginUserDetails.is_partner === "0") && (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 200, hide: 200 }}
                      overlay={
                        <Tooltip id={"practiceLocationUpdate" + row.id}>
                          Click here to select practices
                        </Tooltip>
                      }
                    >
                      <Button
                        id={"practiceLocationUpdate" + row.id}
                        style={buttonToLinkHistory}
                        onClick={() => handlePracticeLocationUpdateClick()}
                        className="mr-3"
                      >
                        <FontAwesomeIcon size="sm" icon={faPencilAlt} />
                      </Button>
                    </OverlayTrigger>
                  )}
                </div>
              </Box>
            </>
          );
        },
      },
      {
        // filterVariant: 'range', //if not using filter modes feature, use this instead of filterFn
        header: "Location History",
        showColumnFilters: false,
        enableResizing: false,
        size: 150,
        csvExport: false,
        //custom conditional format and styling
        Cell: ({ cell, row, renderedCellValue }) => {
          return (
            <>
              <Fragment>
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 200, hide: 200 }}
                  overlay={
                    <Tooltip>Click here to check location history</Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    icon={faClockRotateLeft}
                    cursor="pointer"
                    onClick={() => {
                      setPracticeLocationHistoryModal(true);
                      setMasterCustIdForPracticeLocationHistory(
                        row.original.master_customer_id
                      );
                    }}
                  />
                </OverlayTrigger>
              </Fragment>
            </>
          );
        },
      },
      {
        accessorKey: "opt_flag",
        header: "API Access",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell) {
            if (cell === "1") {
              return "ON";
            } else {
              return "OFF";
            } 
          }else{
            return "--"
          }
        },
        sort: true,
        csvExport: true,
        enableResizing: false,
        filterVariant: "select",
        filterFn: (row, id, filterValue) => {
          if (filterValue === "ON") {
            return row.getValue(id) === "1";
          } else if (filterValue === "Turn OFF") {
            return row.getValue(id) === "0";
          } else {
            return row.getValue(id);
          }
        },
        filterSelectOptions: apiAccessListForFilter,
        showColumnFilters: true,
        size: 150,

        //custom conditional format and styling
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          return loginUserDetails.is_partner === "0" ? (
            <ButtonGroup>
              <Button
                id="btnOnAc"
                size="sm"
                className={
                  renderedCellValue === "1"
                    ? "btn btn-xs btn-success"
                    : "btn btn-xs btn-secondary"
                }
                onClick={() => {
                  if (renderedCellValue !== "1") {
                    setUpdateDataFlag(false);
                    setApiAccessData({
                      currentAPIAccess: "1",
                      data: row.original,
                    });
                    apiAccessLocationSavedRef.current = false;
                    pendingLocationBodyRef.current = null;
                    setIsApiAccessOnFlow(true);
                    setSelectedMasterCustIDPracLocation(
                      row.original.master_customer_id
                    );
                    setSelectCustomerForPracticeLocationUpdate(row.original);
                    setEditPracticeLocationModal(true);
                  }
                }}
              >
                ON
              </Button>
              <Button
                id="btnOffAc"
                size="sm"
                className={
                  renderedCellValue === "1"
                    ? "btn btn-xs btn-secondary"
                    : "btn btn-xs btn-danger"
                }
                onClick={() => {
                  if (renderedCellValue !== "0") {
                    setApiAccessCommentModal(true);
                    setUpdateDataFlag(false);
                    setApiAccessData({
                      currentAPIAccess: "0",
                      data: row.original,
                    });
                  }
                }}
              >
                OFF
              </Button>
            </ButtonGroup>
          ) : (
            <ButtonGroup>
              {renderedCellValue === "1" && (
                <Button
                  id="btnOffAc"
                  size="sm"
                  className="btn btn-xs btn-danger"
                  onClick={() => {
                    if (renderedCellValue !== "0") {
                      setApiAccessCommentModal(true);
                      setUpdateDataFlag(false);
                      setApiAccessData({
                        currentAPIAccess: "0",
                        data: row.original,
                      });
                    }
                  }}
                >
                 Turn OFF
                </Button>
              )}
            </ButtonGroup>
          );
        },
      },
      
      {
        accessorKey: "is_data_available", //simple recommended way to define a column
        header: "Is Data Availabale",
        csvFormatter: (cell, row, rowIndex) => {
          if (cell === "") {
            return "--";
          } else {
            return cell;
          }
        },
        sort: true,
        csvExport: true,

        showColumnFilters: true,
        enableResizing: true,
        size: 350,
        enableClickToCopy: true,
        enableSorting: false,
        //custom conditional format and styling
        Cell: ({ cell, row, renderedCellValue }) => {
          return (
            <>
              {row.original.opt_flag === "1" ? (
                <Fragment>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 200, hide: 200 }}
                    // delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("deletePaymentCardBtn" + row.id)}
                  >
                    <Button
                      className="btn btn-success btn-xs"
                      onClick={() => {
                        setSelectedMasterCustomerID(
                          row.original.master_customer_id
                        );
                        setShowDataAvailableModal(true);
                      }}
                    >
                      Check
                    </Button>
                  </OverlayTrigger>
                </Fragment>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  }

  exportToCsv(activity, materialColumns);

  useEffect(() => {
    if (appid) {
      setUpdateDataFlag(true);
    } else {
      setActivity([]); /// So when is appId is undefined the PartnerCustomerList will set to Empty
    }
  }, [appid]);

  useEffect(() => {
    if (appid && updateDataFlag) {
      setLoading(true);
      var apiParam = { appid: appid };
      APICall.servertrip(
        "GET",
        "partners_customer_list",
        loginUserDetails,
        apiParam
      ).then(
        (res) => {
          const customerItems = Array.isArray(res?.data?.items)
            ? res.data.items
            : [];
          setActivity(
            customerItems.map((data, index) => ({ ...data, id: index }))
          );
          setPartnerCustomerListForLiveUpdate(
            customerItems.map((data, index) => ({ ...data, id: index }))
          );
          setLoading(false);
          setUpdateDataFlag(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoading(false);
          toast.error(resMessage);
          setUpdateDataFlag(false);
        }
      );
    } else {
      setLoading(false);
    }
  }, [appid, updateDataFlag, isRefresh]);
  
  useEffect(() => {
    if (showMasterCustomerHistoryModal) {
      setLoading(true);
      let apiParam = {
        master_customer_id: selectedPartnerCustomer.master_customer_id,
        app_id: appid,
      };
      APICall.servertrip(
        "GET",
        "master_customer_id_api_access_history",
        loginUserDetails,
        apiParam
      ).then(
        (res) => {
          setMasterCustomerHistoryData(res?.data?.items);
          setLoading(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoading(false);
          toast.error(resMessage);
        }
      );
    }
  }, [showMasterCustomerHistoryModal, isRefresh]);

  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {
      position: "relative",
      float: "left",
      padding: "4px 12px",
      "line-height": "1.42857143",
      "text-decoration": "none",
      border: "1px solid #ddd",
    };
    if (active) {
      activeStyle.backgroundColor = "#2c7be5";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "#2c7be5";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "#2c7be5";
    }
    return (
      <li className="page-item">
        <a href="/#" onClick={handleClick} style={activeStyle}>
          {page}
        </a>
      </li>
    );
  };

  const paginationTotalRenderer = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total fs--1 pl-3">
      Showing {from} to {to} of {size}
    </span>
  );

  const options = {
    sizePerPage: 6,
    hideSizePerPage: false, // Hide the sizePerPage dropdown always
    showTotal: true,
    pageButtonRenderer,
    paginationTotalRenderer,
  };

  const fetchPartnerCustomerList = () => {
    return APICall.servertrip(
      "GET",
      "partners_customer_list",
      loginUserDetails,
      { appid: appid }
    ).then((res) => {
      let rows = (Array.isArray(res?.data?.items) ? res.data.items : []).map(
        (data, index) => ({ ...data, id: index })
      );
      setActivity(rows);
      setPartnerCustomerListForLiveUpdate(rows);
      return rows;
    });
  };


  const handleAddingSelectedPractice = () => {
    if (Object.keys(addCustomerParams).length === 0) {
      setNoSearchCustomers(true);
      return;
    }
    const masterCustomerId = addCustomerParams.master_customer_id;
    const existingCustomer = activity.find(
      (row) => row.master_customer_id === masterCustomerId
    );
    if (existingCustomer?.api_unique_id) {
      toast.error("This customer already exists.");
      return;
    }
      setPendingCustomerParams(addCustomerParams);
      setAddCustomerModal(false);
      setNoSearchCustomers(false);
      setIsNewCustomerFlow(true);
      setSelectedMasterCustIDPracLocation(masterCustomerId);
      setSelectCustomerForPracticeLocationUpdate({
        master_customer_id: masterCustomerId,
        api_unique_id: "",
        practice_id: "",
        practice_id1: "",
        billing_mapping: "",
        billing_location: "",
      });
      setEditPracticeLocationModal(true);
  };

  const createPendingCustomer = () => {
    if (!pendingCustomerParams.master_customer_id) {
      return Promise.reject(new Error("No customer selected to add."));
    }
    if (pendingCustomerCreationRef.current) {
      return pendingCustomerCreationRef.current;
    }
    const creationPromise = APICall.servertrip(
      "POST",
      "auth_practice_details",
      loginUserDetails,
      undefined,
      {
        ...pendingCustomerParams,
        opt_flag: "1",
        old_flag: "0",
        request_from: "PortalPracticeLocationSelection",
      }
    )
      .then(() => fetchPartnerCustomerList())
      .then((rows) => {
        const masterCustomerId =
        pendingCustomerParams.master_customer_id;
        const addedCustomer = rows.find(
          (row) => row.master_customer_id === masterCustomerId
        );
        if (!addedCustomer) {
          throw new Error(
            "Customer was saved but could not be loaded. Please refresh the list."
          );
        }
        return addedCustomer;
      })
      .finally(() => {
        pendingCustomerCreationRef.current = null;
      });
    pendingCustomerCreationRef.current = creationPromise;
    return creationPromise;
  };

  const resetNewCustomerFlow = () => {
    setIsNewCustomerFlow(false);
    setPendingCustomerParams({});
    setAddCustomerParams({});
    newCustomerAccessSavingRef.current = false;
  };

  const handleApiAccessLocationsSaved = (locationBody) => {
  apiAccessLocationSavedRef.current = true;
  pendingLocationBodyRef.current = locationBody
    ? { ...locationBody, source: "MasterIdAccessOnOff" }
    : null;
  setApiAccessCommentModal(true);
};
  const handleNewCustomerSaved = (createdCustomer) => {
    if (!createdCustomer?.api_unique_id) {
      toast.error("Customer was not created successfully.");
      resetNewCustomerFlow();
      setUpdateDataFlag(true);
      return;
    }
    if (createdCustomer.opt_flag === "1") {
      toast.success("Customer added with API access enabled.");
      resetNewCustomerFlow();
      setUpdateDataFlag(true);
      return;
    }
    if (newCustomerAccessSavingRef.current) {
      return;
    }
    newCustomerAccessSavingRef.current = true;
    setLoading(true);
    APICall.servertrip(
      "POST",
      "auth_practice_details",
      loginUserDetails,
      undefined,
      {
        ...pendingCustomerParams,
        uid: createdCustomer.api_unique_id,
        opt_flag: "1",
        old_flag: "0",
        comment: "API access enabled after selecting practice location(s).",
        request_from: "PortalPracticeLocationSelection",
      }
    ).then(
      () => {
        toast.success("Customer added with API access enabled.");
        setLoading(false);
        resetNewCustomerFlow();
        setUpdateDataFlag(true);
      },
      (error) => {
        const resMessage =
        error?.response?.data?.message ||
        error?.message ||
        error?.toString();
        toast.error(resMessage);
        setLoading(false);
        resetNewCustomerFlow();
        setUpdateDataFlag(true);
      }
    );
  };

  //https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Bootstrap%204&selectedStory=Column%20Toggle%20with%20bootstrap%204&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
  //https://codesandbox.io/s/react-bootstrap-table-paging-example-mxdx6?from-embed
  //https://allenfang.github.io/react-bootstrap-table/example.html#custom

  return (
    <Fragment>
      <Card className="mb-3">
        <div>
          <SikkaCardHeader title="Partner's Customer List" light={true}>
            <div className="d-flex flex-wrap flex-sm-nowrap">
              <ButtonIcon
                color="outline-primary"
                size="sm"
                icon="Sync"
                className="ml-1 mt-lg-0 mb-2"
                iconClassName="fs--2"
                onClick={() => {
                  setUpdateDataFlag(true);
                }}
              >
                <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faSync} />
                Refresh
              </ButtonIcon>
              {applicationList?.length > 0 &&
              (loginUserDetails.is_partner === "1" ||
                (loginUserDetails.is_partner === "0" &&
                  isActionAllowed("liAddDemoPracticeButton"))) ? (
                <ButtonIcon
                  icon="plus"
                  transform="shrink-3 down-2"
                  color="outline-primary"
                  size="sm"
                  className="mx-1 mt-lg-0 mb-2"
                  onClick={() => setDemoPracticesModal(true)}
                >
                  Demo Practices
                </ButtonIcon>
              ) : (
                <div />
              )}
              {(loginUserDetails.is_partner === "1" &&
                (loginUserDetails.user_type.toLowerCase() === "super admin" ||
                  loginUserDetails.user_type.toLowerCase() === "admin")) ||
              (loginUserDetails.is_partner === "0" &&
                isActionAllowed("liTransferCustomerButton")) ? (
                applicationList?.length > 1 && (
                  <ButtonIcon
                    icon={faRightLeft}
                    transform="shrink-3 down-2"
                    color="outline-primary"
                    size="sm"
                    className="mx-1 mt-lg-0 mb-2"
                    onClick={() => setTransferCustomerModal(true)}
                  >
                    Transfer
                  </ButtonIcon>
                )
              ) : (
                <></>
              )}
              {isActionAllowed("liAddCustomerButton") &&
                applicationList?.length > 0 && (
                  <ButtonIcon
                    icon="plus"
                    transform="shrink-3 down-2"
                    color="outline-primary"
                    size="sm"
                    className="mx-1 mt-lg-0 mb-2"
                    onClick={() => setAddCustomerModal(true)}
                  >
                    Customer
                  </ButtonIcon>
                )}
            </div>
          </SikkaCardHeader>

          <CardBody className="p-0">
            <APIPortalTable
              data={activity}
              columns={filteredColumns}
              loading={loading}
              enablePagination
              CSVFileName={`${
                applicationDetails.app_name
              }_Partner's_customer_list_${new Date().getMonth() +
                1}/${new Date().getDate()}/${new Date().getFullYear()}.csv`}
            />
          </CardBody>
        </div>
      </Card>
      <ModalCustom
        title="Add Comment"
        openPopup={apiAccessCommentModal}
        setOpenPopup={setApiAccessCommentModal}
        size="md"
      >
        <PartnerCustomerListApiAccessModal
          setApiAccessCommentModal={setApiAccessCommentModal}
          handleUserTypeUpdateClick={handleUserTypeUpdateClick}
        />
      </ModalCustom>
      <ModalCustom
        title="API Access History"
        openPopup={showMasterCustomerHistoryModal}
        setOpenPopup={setShowMasterCustomerHistoryModal}
        size="lg"
        customClass="p-0"
      >
        <MasterCustomerHistoryModal
          masterCustomerHistory={masterCustomerHistory}
        />
      </ModalCustom>
      <ModalCustom
        title="Update User Email"
        openPopup={showUserUpdateEmailModal}
        setOpenPopup={setShowUserUpdateEmailModal}
        size="lg"
      >
        <UserUpdateEmailModal
          devid={devid}
          selectedPartnerCustomer={selectedPartnerCustomer}
          setShowUserUpdateEmailModal={setShowUserUpdateEmailModal}
          applicationDetails={applicationDetails}
          setUpdateDataFlag={setUpdateDataFlag}
        />
      </ModalCustom>
      <ModalCustom
        title="Practice Key(s)"
        openPopup={keyBtnModal}
        setOpenPopup={setKeyBtnModal}
        size="xl"
        customClass="p-0"
      >
        <RequestKeyModal masterCustomerID={selectedMasterCustomerID} />
      </ModalCustom>

      <ModalCustom
        title="API Details"
        openPopup={showDataAvailableModal}
        setOpenPopup={setShowDataAvailableModal}
        size="lg"
        customClass="p-0"
      >
        <ShowDataAvailableModal masterCustomerID={selectedMasterCustomerID} />
      </ModalCustom>
      <ModalCustom
        title="Add New Demo Practice"
        openPopup={demoPracticesModal}
        setOpenPopup={setDemoPracticesModal}
        size="lg"
        customClass="p-0"
      >
        <DemoPracticesModal
          devid={devid}
          setDemoPracticesModal={setDemoPracticesModal}
          applicationDetails={applicationDetails}
          setUpdateDataFlag={setUpdateDataFlag}
        />
      </ModalCustom>
      <ModalCustom
        title="Practice Location History"
        openPopup={practiceLocationHistoryModal}
        setOpenPopup={setPracticeLocationHistoryModal}
        size="xl"
        customClass="p-0"
      >
        <PracticeLocationHistoryModal
          masterCustIdForPracticeLocationHistory={
            masterCustIdForPracticeLocationHistory
          }
          appid={appid}
        />
      </ModalCustom>

      <Modal
        size="xl"
        isOpen={addCustomerModal}
        toggle={() => {
          setAddCustomerModal(false);
        }}
        onClosed={() => {
          setSearchedCustomers([]);
          setAddCustomerModal(false);
          setAddCustomerParams({});
        }}
        scrollable={true}
        centered
        autoFocus={false}
        // style={{ maxWidth: "700px", width: "100%" }}
      >
        <ModalHeader
          toggle={() => {
            setAddCustomerModal(!addCustomerModal);
          }}
        >
          Add New Customer
        </ModalHeader>
        {/* <Form className="position-relative"> */}
        <ModalBody className="fs--1 font-weight-normal">
          <AddNewCustomerModal
            noSearchCustomers={noSearchCustomers}
            setNoSearchCustomers={setNoSearchCustomers}
            applicationDetails={applicationDetails}
            appid={appid}
            devid={devid}
            setAddCustomerParams={setAddCustomerParams}
          />
        </ModalBody>
        <ModalFooter className="d-flex text-right">
          <Button
            size="sm"
            className="sm ml-auto mr-1"
            color="outline-success"
            onClick={handleAddingSelectedPractice}
          >
            Next
          </Button>

          <Button
            size="sm"
            color="outline-danger"
            onClick={() => {
              setAddCustomerModal(false);
              setNoSearchCustomers(false);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
        {/* </Form> */}
      </Modal>
      <ModalCustom
        title="Transfer Practices"
        openPopup={transferCustomerModal}
        setOpenPopup={setTransferCustomerModal}
        size="xl"
        customClass="p-0"
      >
        <TransferCustomerModal
          applicationList={applicationList}
          setTransferCustomerModal={setTransferCustomerModal}
          devid={devid}
          setUpdateDataFlag={setUpdateDataFlag}
          applicationDetails={applicationDetails}
        />
      </ModalCustom>

      <ModalCustom
        title="User can access only selected practice(s) data"
        openPopup={editPracticeLocationModal}
        setOpenPopup={setEditPracticeLocationModal}
        size="xl"
        customClass="p-0"
      >
        <EditPracticeLocationModal
          masterCustomerID={selectedMasterCustIDPracLocation}
          devid={devid}
          applicationDetails={applicationDetails}
          activity={
            isNewCustomerFlow
              ? activity.concat([selectCustomerForPracticeLocationUpdate])
              : activity
          }
          selectCustomerForPracticeLocationUpdate={
            selectCustomerForPracticeLocationUpdate
          }
          setEditPracticeLocationModal={setEditPracticeLocationModal}
          setUpdateDataFlag={setUpdateDataFlag}
          isActionAllowed={isActionAllowed}
          isNewCustomerFlow={isNewCustomerFlow}
          isApiAccessOnFlow={isApiAccessOnFlow}
          onCreateCustomer={isNewCustomerFlow ? createPendingCustomer : undefined}
          onSaveSuccess={
            isNewCustomerFlow
              ? handleNewCustomerSaved
              : isApiAccessOnFlow
              ? handleApiAccessLocationsSaved
              : undefined
          }
        />
      </ModalCustom>
      <ModalCustom
        title={"SPU Details : " + selectedMasterCustIDPracLocation}
        openPopup={openSPCDetailsModal}
        setOpenPopup={setOpenSPCDetailsModal}
        size="xl"
        customClass="p-0"
      >
        <SPCDetailsModal
          applicationDetails={applicationDetails}
          masterCustomerID={selectedMasterCustIDPracLocation}
        />
      </ModalCustom>
      <Modal
        title="Practice Location Address"
        isOpen={openPopupAddressModal}
        onClosed={() => {
          setOpenPopupAddressModal(false);
        }}
        centered
        autoFocus={true}
        size="md"
      >
        <ModalHeader
          toggle={() => {
            setOpenPopupAddressModal(false);
          }}
        >
          Practice Location Address
        </ModalHeader>
        <ModalBody className="fs--1 font-weight-normal">
          <span>{practiceLocationAddress}</span>
        </ModalBody>
      </Modal>
      <ModalCustom
        title="Add to Demo Account?"
        openPopup={openAddDemoPracticeModal}
        setOpenPopup={setOpenAddDemoPracticeModal}
        size="md"
        customClass="p-0"
      >
        <AddTestingDemoPracticeModal
          isDemoAccountSelection={isDemoAccountSelection}
          setOpenAddDemoPracticeModal={setOpenAddDemoPracticeModal}
          activity={activity}
          setUpdateDataFlag={setUpdateDataFlag}
        />
      </ModalCustom>
      <ModalCustom
        title={`Payment API Configuration for ${
          configureSelectedRow.original?.master_customer_id
        }`}
        openPopup={openPaymentApiConfModal}
        setOpenPopup={setOpenPaymentApiConfModal}
        size="lg"
        customClass="p-2 payment-api-configuration-model"
      >
        <PaymentApiConfigurationModal
          openPaymentApiConfModal={openPaymentApiConfModal}
          setOpenPaymentApiConfModal={setOpenPaymentApiConfModal}
          setUpdateDataFlag={setUpdateDataFlag}
          selectedRow={configureSelectedRow}
          AppId={appid}
        />
      </ModalCustom>
    </Fragment>
  );
};

export default PartnerCustomerList;
